import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/** component to show and change an emoji as avatar */
@Component( {
    selector: 'riege-avatar-selector',
    styleUrls: ['./avatar-selector.component.scss'],
    templateUrl: './avatar-selector.component.html',
    standalone: true,
    imports: [MatIconModule, CommonModule]
} )
export class AvatarSelectorComponent implements OnInit, OnChanges {
    /** element reference on avatar selector */
    @ViewChild( 'avatarSelect' ) avatarSelect: ElementRef<HTMLElement> | undefined;

    /** data binding on currently choosen emoji */
    @Input() avatar = 'avatar_placeholder';
    /** flag, if avatar should be editable */
    @Input() editable = false;
    /** event emitter, which is called, when emoji has been changed by user */
    @Output() readonly avatarChanged = new EventEmitter();

    /** reference on current avatar */
    avatarImage = '';

    /**
     * flag, if selector menu should be shown
     * default = false
     *
     * - the selector menu is hidden
     */
    showSelector = false;

    /** list of emojis shown in selector menu */
    emojis = [
        'avatar_placeholder',
        'scope-bubbly-rabbit',
        'scope-bumble-bee',
        'scope-clumsy-penguin',
        'scope-cool-specialist',
        'scope-cuddly-cat',
        'scope-devoted-dog',
        'scope-happy-specialist',
        'scope-mad-monkey',
        'scope-majestic-unicorn',
        'scope-organized-ox',
        'scope-pumpkin',
        'scope-sneaky-snake',
        'scope-lovestruck-specialist',
        'scope-celebrating-specialist',
        'scope-crying-specialist',
        'scope-clever-nerd',
        'scope-laughing-specialist',
        'scope-sombrero',
        'scope-heart',
        'scope-flexed-biceps',
        'scope-skull',
        'scope-plane',
        'scope-delivery-truck',
        'scope-articulated-lorry',
        'scope-container',
        'scope-ship',
        'scope-soccer-ball'
    ];

    /** on init, set avatar image, when given */
    ngOnInit(): void {
        this.avatarImage = this.avatar;
    }

    /** if avatar has been changed, update avatar image */
    ngOnChanges() {
        this.avatarImage = this.avatar;
    }

    /**
     * toogles (show/hide) selector menu
     * @param event
     */
    toggleSelector() {
        this.showSelector = !this.showSelector;
    }

    navigateCustomKeys( event: any ) {
        const avatarFlyoutItem = document.querySelectorAll<HTMLElement>( '.emoji-menu__item' );

        this.handleKeyEvent( event );

        avatarFlyoutItem.forEach( ( item, index ) => {
            item.style.border = index === event.target.dataset.index ? '2px solid #000' : 'none';
        } );

        event.preventDefault();
        event.stopPropagation();
    }

    handleKeyEvent( event: any ) {
        const iconSet = this.emojis[event.target.dataset.index] !== undefined;
        switch ( event.key && iconSet ) {
            case 'Escape':
                this.showSelector = false;
                this.avatarSelect?.nativeElement.focus();
                break;

            case 'Enter':
                this.selectAvatar( this.emojis[event.target.dataset.index] );
                break;

            case 'ArrowLeft':
            case 'ArrowUp':
                if ( event.target.previousElementSibling !== null ) {
                    if ( event.target.previousElementSibling.className.includes( 'emoji-menu__item--active' ) ) {
                        event.target.previousElementSibling.previousElementSibling.focus();
                    } else {
                        event.target.previousElementSibling.focus();
                    }
                }
                break;

            case 'ArrowRight':
            case 'ArrowDown':
                if ( event.target.nextElementSibling !== null ) {
                    if ( event.target.nextElementSibling.className.includes( 'emoji-menu__item--active' ) ) {
                        event.target.nextElementSibling.nextElementSibling.focus();
                    } else {
                        event.target.nextElementSibling.focus();
                    }
                }
                break;
        }
    }

    /**
     * helper function to change avatar
     * calls event emitter, to broadcast event to parent component
     * @param emoji
     */
    selectAvatar( emoji: string ) {
        if ( this.avatarChanged && this.avatarImage !== emoji ) {
            this.avatarImage = emoji;

            this.avatarChanged.emit( emoji );
        }
    }
}
